module.exports = __webpack_public_path__ + "img/lifestyle_circle_frame_01.8e108c3f.png";